import { useRouter } from '@capsicum/common-web';
import { usePostSurveyVoteBySurveyId } from '@capsicum/features/survey/shared';

type UseSurveyVoteFlowProps = {
	isNCWFlow?: boolean;
	partnerId: string;
	surveyId: string;
};

export const useSurveyVoteFlow = ({ isNCWFlow, partnerId, surveyId }: UseSurveyVoteFlowProps) => {
	const { replace } = useRouter();
	const {
		isVoteError: isCustodialVoteError,
		isVoteProcessing: isCustodialVoteProcessing,
		isVoteSuccessful: isCustodialVoteSuccessful,
		submitVote: submitCustodialVote
	} = usePostSurveyVoteBySurveyId(partnerId, surveyId);

	const navigateToVotePage = (selectedAnswerId: string) =>
		replace(`/votes/${partnerId}/${surveyId}/${selectedAnswerId}`);

	const onSubmitHandler = (selectedAnswerId: string) =>
		isNCWFlow
			? navigateToVotePage(selectedAnswerId)
			: submitCustodialVote({ answerId: selectedAnswerId, surveyId });

	return {
		isCustodialVoteError,
		isCustodialVoteProcessing,
		isCustodialVoteSuccessful,
		isNCWFlow,
		onSubmitHandler
	};
};
